const selectMany = <TSource, TSelect>(source: TSource[], select: (x: TSource) => TSelect[]): TSelect[] => {
    let result: TSelect[] = [];

    source.forEach(x => Array.prototype.push.apply(result, select(x)));

    return result;
};

export default selectMany;
